import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
import ImageViewer from '../../../content_viewer/viewers/image_viewer.vue';
export default {
    name: 'TwoUpViewer',
    components: {
        ImageViewer
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        newPath: {
            type: String,
            required: true
        },
        oldPath: {
            type: String,
            required: true
        },
        newSize: {
            type: Number,
            required: false,
            default: 0
        },
        oldSize: {
            type: Number,
            required: false,
            default: 0
        },
        encodePath: {
            type: Boolean,
            required: false,
            default: true
        }
    }
};
